module.exports = __webpack_public_path__ + "static/media/type.1f2964b3.svg";